const messages = {
    /* Таблицы */
    dataIterator: {
        rowsPerPageText: "Items per page:",
        rowsPerPageAll: "All",
        pageText: "{0}-{1} of {2}",
        noResultsText: "No matching records found",
        nextPage: "Next page",
        prevPage: "Previous page"
    },
    dataTable: {
        rowsPerPageText: "Rows per page:"
    },
    noDataText: "No data available",
    carousel: {
        prev: "Previous visual",
        next: "Next visual"
    },

    errors: {
        accountConfirmationError: "Account confirmation error",
        cantUpdateUsersSettings: "Can't update user's settings",
        emptyPatterns: "Check lumber parameters and presence of selected cross-sections",
        errorMethod: "You should select the method for log volume calculation in parameters",
        fbsDiamMaxLog: "(Chipper) Maximum allowable log diameter exceeded",
        noConfirmationCodeError: "Confirmation code not found. Possibly account already confirmed",
        noOptimalPattern: "As a result of calculations, there are no optimal sawing patterns. Check the parameters of equipment, required lumber and logs. Then repeat the calculation",
        noSawDevices: "There is no sawing equipment on the processing line",
        serverConnectionError: "Unable to connect to the server. Please try again later",
        volumeTableDataNotFound: "The volume table does not contain data for the specified diameter and length values"
    },

    monthsList: {
        january:   "January",
        february:  "February",
        march:     "March",
        april:     "April",
        may:       "May",
        june:      "June",
        july:      "July",
        august:    "August",
        september: "September",
        october:   "October",
        november:  "November",
        december:  "December"
    },

    lineTemplates: {
        cant: "Cant",
        liveCut: "Live cut",
        multiSawsFrame: "Multi-saws frame",
        profilingLine: "Profiling line",
        chipperCanter: "Chipper-canter",
        scandinavian: "Scandinavian scheme",
        torsion: "Torsion sawing",
        bandLine: "Band sawmill",
        bandLineWithMulti: "Band sawmill with multi-saws frame",
        bandLineWithRotate: "Band sawmill with rotation"
    },

    volumeCalcMethods: {
        topDiamAvgRise: "Top diameter and average taper",
        truncatedCone: "Truncated cone",
        endSections: "End cross-sections",
        standardTables: "Standards tables"
    },

    gosStandards: {
        gost2708_75: "GOST (State Standard) 2708-75",
        gost_r54365_2011: "GOST (State Standard) R54365-2011",
        gost2708_75Short: "GOST 2708-75",
        gost_r54365_2011Short: "GOST R54365-2011"
    },

    notes: {
        trialAvailability: "Trial version is available immediately after registration",
        billExist: "Bill has already been created for you. Creating a new bill cancels the old one.",
        successBillSubmition: "The invoice has been generated and sent to the specified email address. Immediately after payment, our staff will provide you with the selected subscription. Enjoy using it!",
        liveCutLine: "This line is standard. It is possible to change the parameters of the multi-saw machine. Adding/removing equipment is prohibited."
    },

    subscriptionPlans: {
        title: "Subscription plans and prices",
        currency: "₽",
        quarterly: "3 months",
        yearly: "1 year",
        threeYear: "3 years",
        free: "Trial",
        standard: "Standard",
        standardPlus: "StandardPlus",
        professional: "Professional",
        availableFeatures: "Functions available",
        restrictions: "Limits",
        usersAmount: "Number of users",
        patternsAmount: "Number of results available for storage in sawing patterns library",
        modelsAmount: "Number of log models available for storage",
        sawProfilesAmount: "Number of equipment profiles",
        features: [
            "Editing catalogs of lumbers, lengths, cost of raw material and product cost",
            "Optimization by volume yield based on nominal and sawing sizes",
            "Optimization by price based on cost dependence on cross-section, lumber length as well as woodchips and sawdust cost",
            "Possibility to create individual sawmill line",
            "Optimization based on edge trimming (cutting unedged board into several edged boards), possibility to cut central sawing pattern",
            "Printable form of optimization report and saving result to library",
            "Viewing 3D models of sawing patterns and logs",
            "Manual creation and editing of sawing patterns",
            "Selection of optimal diameter for sawing pattern and diameters range for efficient sawing",
            "Optimization results saving to library, export and import",
            "Optimization based on log curvature",
            "Optimization based on log ovality",
            "Calculation based on allowable wane and board without a core",
            "Integration with other \"Avtomatika-Vektor\" products"
        ],
    },

    paymentTypes: {
        bankcard: "Bank card",
        sbp: "Fast payment system",
        bill: "Payment bill",
        bankcardAndSbp: "Bank card and Fast payment system"
    },

    /* Модули */
    calc: "Optimization",
    general: "System",
    lines: "Lines",

    appName: "MillLab",
    avtomatikaVektor: "Avtomatika-Vektor",
    vektorPromSoft: "VektorPromSoft",

    acceptCookies: "Accept and close",
    acceptLicense: "Accept license agreement",
    acceptPolicy: "Accept privacy policy",
    accessControl: "Access control",
    accessDenied: "Access denied",
    accountConfirmed: "Account confirmed",
    aclCreate: "Create",
    aclDelete: "Delete",
    aclExport: "Export",
    aclModify: "Modify",
    aclRead: "Read",
    aclUpdated: "Access control list updated",
    action: "Action",
    actualSizes: "actual",
    addLineTemplate: "Add line template",
    address: "Address",
    administration: "Admin",
    administrator: "Administrator",
    all: "All",
    alongCurvature: "Along curvature",
    alongLogAxis: "Processing along the central axis of the log",
    amount: "Amount",
    amountIn: "Amount in",
    amountShort: "Am.",
    and: "and",
    applicationError: "Application error",
    apply: "Apply",
    archived: "Archived",
    aspen: "Aspen",
    asymmetric: "Asymmetric",
    attention: "Attention!",
    atTheButt: "At the butt",
    atTheTop: "At the top",
    authorization: "Authorization",
    auto: "Auto",
    automaticallyCalculateTaper: "Automatically calculate taper",
    averageTaper: "Average taper",
    avgCurv: "Avg. curv.",
    avgCurvature: "Avg. curvature",
    batchOfLogs: "Batch of logs",
    bandSaw: "Band saw",
    bandSawShort: "Band saw",
    bark: "Bark",
    birch: "Birch",
    boards: "Boards",
    boardsCuttingPossibility: "Possibility of dissolving boards",
    boardsParameters: "Boards parameters",
    boardsVolume: "Boards volume",
    boardsV: "Boards vol",
    boardType: "Board type",
    bottom: "Bottom",
    byCantWidth: "By cant width",
    byPrice: "By price",
    byVolume: "By volume",
    buySubscription: "Buy subscription",
    calculate: "Calculate",
    calculated: "Calculated",
    calculatedBoards: "Calculated boards",
    calculationError: "Calculation error",
    calculation: "Calculation",
    calculations: "Calculations",
    calculationDelete: "Delete calculation",
    calculators: "Сalculators",
    calculateAmount: "The amount of lumber in the specified cubic meters",
    calculateVolume: "The volume of lumber from the specified quantity",
    cancel: "Cancel",
    cantCreateCompany: "Can't create company",
    cantCreateContract: "Can't create contract",
    cantCreateDimension: "Can't create cross-section",
    cantCreateLength: "Can't create length record",
    cantCreateUser: "Can't create user",
    cantDeleteCompany: "Can't delete company",
    cantDeleteContract: "Can't delete contract",
    cantDeleteDimension: "Can't delete cross-section",
    cantDeleteLength: "Can't delete length",
    cantDeleteLumber: "Can't delete lumber",
    cantDeleteLumberGroup: "Can't delete lumber group",
    cantDeleteModel: "Can't delete model",
    cantDeletePattern: "Can't delete sawing pattern",
    cantDeletePrice: "Can't delete price",
    cantDeleteProfile: "Can't delete profile",
    cantDeleteUser: "Can't delete user",
    cantLoad3DModelData: "Can't load 3D model data",
    cantLoad3DModelsData: "Can't load 3D models data",
    cantLoadACL: "Can't load access control list",
    cantLoadCalcMethodsData: "Can't load calculation methods data",
    cantLoadCompaniesData: "Can't load companies data",
    cantLoadContractsData: "Can't load contracts data",
    cantLoadConfig: "Can't load configuration",
    cantLoadData: "Can't load data",
    cantLoadDimensionsData: "Can't load data on cross-sections",
    cantLoadEquipmentData: "Can't load equipment data",
    cantLoadEquipmentProfiles: "Can't load equipment profiles",
    cantLoadEventsData: "Can't load events data",
    cantLoadGroupsData: "Can't load groups data",
    cantLoadLengthsData: "Can't load lengths data",
    cantLoadLoginInfo: "Can't load login info",
    cantLoadLumberData: "Can't load lumber data",
    cantLoadModulesData: "Can't load modules data",
    cantLoadPatternsData: "Can't load sawing patterns data",
    cantLoadPricesData: "Can't load prices data",
    cantLoadProfiles: "Can't load profiles",
    cantLoadSettings: "Can't load settings",
    cantLoadSpeciesData: "Can't load species data",
    cantLoadSubscriptionInfo: "Can't load subscription info",
    cantLoadSystemLog: "Can't load system log",
    cantLoadTasksData: "Can't load tasks data",
    cantLoadUserInfo: "Can't load user info",
    cantLoadUsersData: "Can't load users data",
    cantProduction: "Cant production",
    cantSaveData: "Can't save data",
    cantSaveLumberGroup: "Can't save lumber group",
    cantSavePattern: "Can't save sawing pattern",
    cantSaveProfile: "Can't save profile",
    cantScanner: "Cant scanner",
    cantSendMessage: "Can't send message",
    cant: "Cant",
    cantType: "Cant type",
    cantOffset: "Сдвиг от центральной оси",
    cantUpdateACL: "Can't update access control list",
    cantUpdateCalculation: "Can't update calculation",
    cantUpdateCompany: "Can't update company data",
    cantUpdateContract: "Can't update contract data",
    cantUpdateData: "Can't update data",
    cantUpdateLength: "Can't update length",
    cantUpdatePrices: "Can't update prices",
    cantUpdateSubscription: "Can't update subscription",
    cantUpdateUser: "Can't update user data",
    cantUploadFile: "Can't upload file",
    cantUploadModel: "Can't upload 3D model",
    cantUploadPattern: "Can't upload sawing pattern",
    captchaAPICallFailed: "An error occurred during the CAPTCHA check, please try again later",
    captchaCheckNegative: "You haven't passed the CAPTCHA check. Your actions are very similar to automated",
    catalogs: "Catalogs",
    cedar: "Cedar",
    centralBoard: "Central board",
    centralBoards: "Central boards",
    centralAndSideBoard: "Central and side board",
    centralBoardsCutting: "Central boards cutting",
    centralBoardsMinTotalThickness: "Min. overall thickness of central boards",
    centralHalfTimberSawing: "Central half-timber sawing",
    centralKerf: "Central kerf",
    circularSaw: "Radial saw",
    circularSawShort: "Radial saw",
    clear: "Clear",
    clearFormRequest: "Do You really want to clear the form?",
    clearTheForm: "Clear the form",
    cleanKerf: "Clean kerf",
    cleanSawsUsed: "Clean saws used",
    close: "Close",
    clickToNavigate: "Click to navigate",
    cm: "cm",
    cookiesPolicy: "Cookies policy",
    cookiesMessageFirstRow: "We use cookies for the best functioning.",
    cookiesMessageSecondRow: "By using our website You consent cookies.",
    companies: "Companies",
    company: "Company",
    comment: "Comment",
    contract: "Contract",
    contracts: "Contracts",
    contractNumber: "Contract number",
    companyAlreadyRegistered: "A company with this name is already registered. To create an account, contact Your system administrator",
    companyCreated: "Company successfully created",
    companyDelete: "Delete company",
    contractDelete: "Delete contract",
    companyName: "Company name",
    companyUpdated: "Company data updated",
    confirm3DModelDelete: "Do You really want to delete 3D model?",
    confirmationCodeNotFound: "Confirmation code not found",
    confirmCalculationDelete: "Do You really want to delete calculation?",
    confirmCompanyDelete: "Do You really want to delete company?",
    confirmContractDelete: "Do You really want to delete contract?",
    confirmDimensionDelete: "Do You really want to delete cross-section?",
    confirmLengthDelete: "Do You really want to delete length?",
    confirmLengthGroupDelete: "Do You really want to delete length group?",
    confirmLumberDelete: "Do You really want to delete lumber?",
    confirmLumberGroupDelete: "Do You really want to delete lumber group?",
    confirmPatternDelete: "Do You really want to delete sawing pattern?",
    confirmPriceDelete: "Do You really want to delete price?",
    confirmProfileDelete: "Do You really want to delete current profile?",
    confirmUnsaved: "You have unsaved changes! Do you really want to leave?",
    confirmUserDelete: "Do You really want to delete user's account?",
    conoidMethod: "By truncated cone",
    contact: "Contact",
    contacts: "Contacts",
    copiedToClipboard: "Copied to clipboard",
    copyToClipboard: "Copy to clipboard",
    corelessBoard: "Board without a core",
    create: "Create",
    createModifyDate: "Date of creation/modification",
    createPatternsLimitReachedMessage: "Subscription limit reached. You can't create more sawing patterns. Try to delete the old ones or consider to change Your subscription.",
    createUsersLimitReachedMessage: "Subscription limit reached. You can't create more users. Try to delete the old ones or consider to change Your subscription.",
    currentEdition: "Current edition",
    currentPattern: "Current pattern",
    curvature: "Curvature",
    curvatureCenter: "Curvature center",
    curvatureSettings: "Curvature settings",
    cuttingOptimization: "Cutting optimization",
    cutWidthAlongTheEdge: "Cut width along the edge",
    cutWidthAlongThePlate: "Cut width along the face",
    customer: "Customer",
    cylinderCant: "Rounded",
    darkTheme: "Dark theme",
    dataSaved: "Data saved",
    dataSaveError: "Data save error",
    dataUpdated: "Data updated",
    date: "Date",
    dButt: "D butt",
    delete: "Delete",
    deleteProfile: "Delete profile",
    denyEdit: "Deny edit",
    denyExport: "Deny export",
    denyImport: "Deny import",
    descriptionStepsToReproduce: "Description (steps to reproduce)",
    diameter: "Diameter",
    diameterCant: "Cant diameter",
    diameterBottom: "Butt diameter",
    diameterShort: "D.",
    //diametersU: "Диаметры учетные *Требуется перевод",
    diameterTop: "Top diameter",
    diameterU: "Accounting diameter",
    dimension: "Cross-section",
    dimensionCreated: "Cross-section created",
    dimensionDelete: "Delete cross-section",
    dimensionUpdated: "Cross-section updated",
    dimensions: "Cross-sections",
    distribution: "Distribution",
    displayPrices: "Display prices",
    displayLogBottom: "Display log bottom",
    displayPatternSizes: "Display pattern sizes",
    disableCalculationMessage: "To perform calculations, it is necessary to select cross-sections and equipment profile. The configuration of the sawmill line is performed in the Catalogs - Equipment Profiles.",
    download: "Download",
    drying: "Druing",
    dTop: "D top",
    dTopShort: "D top",
    edit: "Edit",
    edited: "Edited",
    editionFrom: "Edition from",
    edgeTrimmer: "Edger",
    edgeTrimmerShort: "Edger",
    edgeTrimmerUsed: "Edge trimmer used",
    ellipseRatio: "Ovality",
    eMail: "E-mail",
    eMailAddress: "E-mail address",
    eMailAddressRejected: "Server rejects entered e-mail address. Please check if it's misspelled",
    eMailIsDisposable: "You cannot use a disposable email address for registration",
    emptyLineErrorMessage: "Can't save empty line",
    endSectionMethod: "By end cross-sections",
    equipment: "Equipment",
    equipmentProfile: "Equipment profile",
    equipmentProfiles: "Equipment profiles",
    error: "Error",
    errorDuringRequest: "There were error during request",
    even: "Even",
    executionTime: "Execution time",
    exit: "Exit",
    expenses: "Expenses",
    expensesM3: "Expenses per m3",
    export: "Export",
    expenditure: "Expenditure",
    exportToExternalApp: "Export to external application",
    falseCore: "False core",
    falseCorePricePrcnt: "Price for lumber with false core, %",
    fbs: "Chipper canter",
    fbsShort: "Chipper",
    fileName: "File name",
    fileNotSelected: "File not selected",
    fileParsingError: "File parsing error",
    fileTooLarge: "Too large file",
    finalValue: "Final value",
    findingTheOptimalDiameter: "Finding the optimal diameter",
    fir: "Fir",
    first3: "First 3",
    first5: "First 5",
    first10: "First 10",
    firstName: "Name",
    firstRun: "First run",
    forgotPassword: "Forgot password",
    fromTopToButt: "From top to butt",
    fromLogVolume: "From log volume",
    fromLumberVolume: "From lumber volume",
    freeSubscriptionInfo: "The trial subscription has a number of limitations.<br>Calculations are available only with standard lumber.<br>Click on the button to go to the page with information about available subscriptions.",
    fullRange: "Full range",
    groupName: "Group name",
    groupNameCantBeEmpty: "Group name can't be empty",
    goToPayment: "Go to payment",
    halfCant: "Half-timber",
    hasCalculations: "There are calculations",
    hasMyCalculations: "There are my calculations",
    help: "Help",
    history: "History",
    home: "Home",
    horizontalSaw: "Horizontal saw",
    horizontalSawShort: "Horiz. saw",
    humidity: "Humidity",
    imageExportCompleted: "Image export completed",
    import: "Import",
    incorrectEMailOrPassword: "Incorrect e-mail or password",
    incorrectValue: "Incorrect value",
    information: "Information",
    initialValue: "Initial value",
    interface: "Interface",
    invalidEMail: "Invalid e-mail address",
    kerf: "Kerf",
    kerfExt: "Kerf ext.",
    kg: "kg",
    labeling: "Labeling",
    language: "Language",
    larch: "Larch",
    lastName: "Last name",
    lastNews: "Last news",
    length: "Length",
    lengthGroup: "Length group",
    lengthGroupDelete: "Length group delete",
    lengthGroupDeleted: "Length group successfully deleted",
    lengthGroupModified: "Length group modified",
    lengthGroups: "Length groups",
    lengthGroupSaved: "Length group saved",
    lengthCreated: "Length record successfully created",
    lengthDelete: "Delete length",
    lengthM: "Length, m",
    lengths: "Lengths",
    lengthsAndVolumes: "Lengths and volumes",
    lengthUpdated: "Length updated",
    libraries: "Libraries",
    licenseAgreement: "License agreement",
    lime: "Lime",
    limits: "Limits",
    line: "Line",
    lineChanged: "Changed",
    lineChangedHint: "Line have unsaved changes",
    load: "Load",
    loadTesting: "Load testing",
    lock: "Lock",
    lockCoreless: "Lock coreless settings",
    lockCurvature: "Lock curvature settings",
    lockWane: "Lock wane settings",
    log: "Log",
    logsAmount: "Amount of logs",
    logDimensions: "Log dimensions",
    logLength: "Log length",
    logParameters: "Log parameters",
    logsParameters: "Logs parameters",
    logsScanner: "Logs scanner",
    logVolume: "Log volume",
    logV: "Log vol.",
    lumber: "Lumber",
    lumberDelete: "Deleting lumber",
    lumberGroup: "Lumber group",
    lumberGroupDelete: "Lumber group delete",
    lumberGroupDeleted: "Lumber group successfully deleted",
    lumberGroupModified: "Lumber group modified",
    lumberGroups: "Lumber groups",
    lumberGroupSaved: "Lumber group saved",
    lumberImport: "Import lumber",
    lumberCalculator: "Lumber Calculator",
    lumbersAmount: "Lumbers amount",
    lumbersVolume: "Lumbers volume (amount of cubes)",
    lumberShrinkage: "Lumber shrinkage",
    lumberShrinkageCalculation: "Lumber shrinkage calculation method",
    lumberWaneCalculation: "Lumber with wane volume calculation method",
    m: "m",
    m3: "m3",
    maxAmount: "Max. number",
    maxCantThickness: "Max. cant thickness",
    maxCurv: "Max. curv.",
    maxCurvature: "Max. curvature",
    maxCuttingDepth: "Max. cutting depth",
    maximalCurvature: "Maximal curvature",
    maxLines: "Max. number of lines",
    maxModels: "Max. number of 3D models",
    maxPatterns: "Max. number of sawing patterns",
    maxProfilingDepth: "Max. profiling depth",
    maxSawsAmount: "Max. number of saws",
    maxSideBoardsAmount: "Max. number of side boards on each side",
    maxUsers: "Max. number of users",
    maxWaneLength: "Max. wane length",
    message: "Message",
    messageSent: "Message sent",
    messageType: "Message type",
    messageEmptyLengthRange: "This field can be left blank, in which case the lengths will be set in a range based on the dimensions of the log",
    //messageTypes: "Message types",
    middleName: "Middle name",
    minCurv: "Min. curv.",
    minCurvature: "Min. curvature",
    minDmm: "Min. diameter, mm",
    minimalCurvature: "Minimal curvature",
    minimalLength: "Minimal length",
    minTopSideBoardsWidth: "Min. width of end boards in top",
    mm: "mm",
    modelDeleteError: "Error. Can't delete model",
    modelDeleted: "Model successfully deleted",
    modified: "Modified",
    module: "Module",
    modules: "Modules",
    ms: "ms",
    multiSaw: "Multisaw",
    multiSawShort: "Multisaw",
    my: "My",
    myAccount: "My account",
    mySubscription: "My subscription",
    name: "Name",
    new: "New",
    newGroup: "New group",
    newProfile: "New profile",
    no: "No",
    noCurv: "No curv.",
    noCurvature: "No curvature",
    noGroup: "No group",
    nominalSize: "Nominal size",
    nominalSizes: "nominal",
    noSpeciesSelectedWarning: "No species selected! Please check the species catalog",
    notLoggedIn: "Not logged in",
    notUsed: "Not used",
    odd: "Odd",
    open: "Open",
    operator: "Operator",
    optimalDiameter: "Optimal diameter",
    optimalDiametersRange: "Optimal diameters range",
    optimization: "Optimization",
    optimizations: "Optimizations",
    optimizationByWidth: "Cutting optimization by width",
    optimizationMethod: "Optimization method",
    optimizerResponseIsNull: "The optimizer did not return a result",
    output: "Output",
    outputDeltaForCalculatingOptimalDiamRange: "Output delta for calculating the optimal diameters range",
    ok: "ok",
    oneItemVolume: "Volume of one unit",
    oneItemWeight: "Weight of one unit",
    oneItemPrice: "Price per unit",
    oneItemExpenses: "Expenses per unit",
    oneM3Weight: "Weight of one m3 of lumber",
    password: "Password",
    passwordCantBeEmpty: "Password can't be empty",
    passwordChanged: "Password successfully changed",
    passwordChangeError: "Password change error",
    passwordConfirm: "Password confirmation",
    passwordReset: "Password reset",
    passwordResetMessageSent: "E-mail with password reset link successfully sent",
    passwordResetReminder: "To reset Your password, enter e-mail address You provided when registering. If you have forgotten Your e-mail, contact Your system administrator or support",
    passwordsMismatch: "Passwords mismatch",
    pattern: "Sawing pattern",
    patternDeleteError: "Can't delete sawing pattern",
    patternDeleted: "Sawing pattern successfully deleted",
    patternExportCompleted: "Pattern export completed",
    patternExportError: "An error occurred while exporting the pattern. The receiving software may be unavailable at this moment. Please try again later.",
    patternName:"Sawing pattern name",
    patterns: "Sawing patterns",
    patternSample: "Pattern example",
    patternsLibrary: "Sawing patterns library",
    patternSolidBackground: "Solid background on pattern",
    patternType: "Sawing pattern type",
    pattern3dView: "Three-dimensional model of a log",
    patternFile: "Pattern file",
    paymentType: "Payment type",
    pc: "pc",
    pieces: "pieces",
    period: "Period",
    //personalCabinet: "Personal cabinet",
    personalDataAgreement: "I agree to the processing of my personal data",
    phone: "Phone",
    pine: "Pine",
    price: "Price",
    priceDelete: "Deleting price",
    prices: "Prices",
    priceM3: "Price for m3",
    print: "Print",
    printBatchOfLogs: "Log batch report",
    privacyPolicy: "Privacy policy",
    profile: "Profile",
    profileDeleted: "Profile successfully deleted",
    profileName: "Profile name",
    profileNameCantBeEmpty: "Profile name can't be empty",
    profilingMachine: "Profiler",
    profilingMachineShort: "Profiler",
    profileSaved: "Profile saved",
    programMaxExecutionTimeExceeded: "Program max execution time exceeded",
    qty: "Qty.",
    rangeOfValues: "Range of values",
    rawMaterials: "Raw materials",
    readOnly: "Read only",
    reCaptchaNoteP1: "This site is protected by reCAPTCHA and the Google",
    reCaptchaNoteP2: " apply",
    rectangle: "Rectangle",
    rectangleCant: "Rectangular",
    registration: "Registration",
    registrationFailed: "Registration failed. Please contact support",
    registrationSuccessful: "Your have successfully registered. The last step is to verify your e-mail address. To do this, click on the link as indicated in the e-mail you received from us",
    registrationAsNaturalPerson: "Registration as natural person",
    reload: "Reload",
    reloginAfterEMailChange: "You need to relogin after changing e-mail address",
    rename: "Rename",
    requestBill: "Request bill",
    requiredField: "Required field",
    requiredFieldIsEmpty: "Required field is empty",
    requiredFieldPointer: "* indicates required field",
    requireValidEmail: "Enter a valid e-mail",
    reset: "Reset",
    report: "Report",
    reports: "Reports",
    rememberMe: "Remember me",
    role: "Role",
    rotate: "Rotate",
    rotateAndPositioningDev: "Rotation and positioning device",
    rotateAndPositioningDevShort: "Rotat. & posit. dev.",
    rotateLog90deg: "Rotate the log 90 degrees",
    rotatePattern: "Rotate pattern",
    rotateToStartPosition: "Reset to start position",
    rotationAngle: "Rotation angle",
    sameWidthSides: "Side boards of the same width",
    sameSizeSides: "Side boards of the same size",
    save: "Save",
    saveAs: "Save as",
    saveGroup: "Save group",
    saveInfo: "Save information",
    savingPatternsAmount: "Saving patterns amount",
    savePattern: "Save sawing pattern",
    saveProfile: "Save profile",
    saveProfilesLimitReachedMessage: "Subscription limit reached. You can't save more equipment profiles. Try to delete the old ones or consider to change Your subscription",
    saw: "saw",
    sawAxis: "Sawing axis",
    sawdust: "Sawdust",
    sawdustPriceM3: "Sawdust price for 1 m3",
    sawingSettings: "Sawing parameters",
    saws: "saws",
    sawSize: "Sawing size",
    sawsThicknessByKerfHeight: "Saws thickness depends on kerf height",
    sawWaste: "Sawing waste",
    sawWidthDependOnKerf: "Saws width depends on kerf height",
    scaleDownByLength: "Compress by length",
    scanner: "Scanner",
    screenshot: "Screenshot",
    search: "Search",
    searchTopics: "Search topics",
    searchLumber: "Search cross-section",
    select: "Select",
    selectAll: "Select All",
    selectCuts: "Select cross-sections",
    selectFile: "Select a file",
    selectImage: "Select image",
    send: "Send",
    sendMailError: "Error: can't send e-mail",
    sessionExpired: "Session expired. You need to relogin",
    sessionIdMismatch: "Session ID mismatch. It is likely that your credentials were used to log in on another computer",
    settings: "Settings",
    settingsSaved: "Settings saved",
    showArchived: "Show archived",
    showCalculations: "Show calculations",
    showCutScheme: "Show cutting scheme",
    showMessage: "Show message",
    showSizes: "Show sizes",
    showAxes: "Central axes",
    sideBoard: "Side board",
    sideBoards: "Side boards",
    sideBoardsSawing: "Side boards sawing",
    singleValue: "Single value",
    site: "Site",
    sorting: "Sorting",
    species: "Species",
    speciesAlt: "Species",
    speciesSwitch: "Switch species",
    speciesSwitchRequest: "Pattern data will be cleared during species switching. Please confirm the operation",
    spruce: "Spruce",
    standards: "Standards",
    start: "Start",
    started: "Started",
    status: "Status",
    step: "Step",
    stop: "Stop",
    stopped: "Stopped",
    subject: "Subject",
    submitApplication: "Submit an application",
    subscription: "Subscription",
    subscriptionAlmostExpired: "Subscription almost expired. Days left:",
    subscriptions: "Subscriptions",
    subscriptionExpired: "Subscription expired",
    subscriptionExpiredDate: "Subscription expired",
    subscriptionLevel: "Subscription level",
    /*
    subscriptionLevel1: "Starter pack",
    subscriptionLevel2: "Economy pack",
    subscriptionLevel3: "SME pack",
    subscriptionLevel4: "Multiuser pack",
    subscriptionLevel5: "Professional pack",
    subscriptionLevel6: "Holding pack",
    */
    subscriptionRenewal: "Subscription renewal",
    subscriptionUpdated: "Subscription updated",
    support: "Support",
    supportHint: "You can send a question to the technical support service, the answer will be sent to the email address specified during registration",
    symmetric: "Symmetric",
    symmetricSideBoards: "Symmetrical side boards adding",
    sysLog: "System log",
    screenPattern: "Pattern screenshot",
    screenPatternWitnInfo: "Pattern with parameters screenshot",
    screenPatternWithFullInfo: "Calculation screenshot",
    tariffs: "Prices",
    tableData: "Table data",
    tablesMethod: "By GOST (State Standard) tables",
    taper: "Taper",
    tasks: "Tasks",
    tasksHistory: "Tasks history",
    termsOfService: "Terms of service",
    test: "Test",
    testReport: "TestReport",
    temporaryLengthChange: "Temporary change in cross-section lengths",
    thickness: "Thickness",
    threeDLibrary: "3D models library",
    threeDModels: "3D models",
    time: "Time",
    title: "Title",
    toggleCuts: "Switch the cuts display mode",
    toggleLog: "Switch the log display mode",
    toggleCurvatureMode: "Toggle curvature display mode",
    topDMethod: "By top diameter and average taper",
    total: "Total",
    totalExecutionTime: "Total execution time",
    totalWeight: "Total weight",
    totalPrice: "Total price",
    totalExpenses: "Total expenses",
    top: "Top",
    tutorials: "Tutorials",
    twoRowsAfterFrame: "After 2nd row frame",
    type: "Type",
    trapeze: "Trapeze",
    tryForFree: "Try it for free",
    unsupportedPattern: "Unsupported pattern",
    unsupportedPatternInfo: "Current version supports the search for the optimal diameter only for the simple patterns which do not contain sawn side or central boards",
    unsupportedPatternInfoInEditDialog: "Current version supports editing only for the simple patterns which do not contain sawn side or central boards",
    uploadModelsLimitReachedMessage: "Subscription limit reached. You can't upload more 3D models. Try to delete the old ones or consider to change Your subscription.",
    uploadPatternsLimitReachedMessage: "Subscription limit reached. You can't upload more patterns. Try to delete the old ones or consider to change Your subscription.",
    user: "User",
    userAlreadyExists: "The user with this e-mail address is already registered, if You have forgotten Your password, go through the password reset procedure, or contact Your system administrator to replace it",
    userCreated: "User's account successfully created",
    userDelete: "Account deleting",
    userInterface: "User interface",
    userRegistered: "Account created. Please check Your e-mail for activation link",
    users: "Users",
    userUpdated: "User data updated",
    userVolumeInput: "Self-input log volume by the user",
    usingCentralAsSide: "Use the selected central sections also as side sections",
    usingWane: "Calculation taking into account the allowable wane",
    validThrough: "Valid until",
    valueAlreadyExists: "Value already exists",
    valueCantBeEmpty: "Value can't be empty",
    volume: "Volume",
    volumeCalculationMethod: "Volume calculation method",
    volumeCalculationMethods: "Volume calculation methods",
    volumeCalculationStandard: "Standards table",
    volumeCalculationStandards: "Standards tables",
    wane: "Wane",
    wanelessCentralBoards: "Waneless central boards",
    waneWidth: "Wane width",
    warning: "Warning",
    width: "Width",
    woodChips: "Wood chips",
    woodChipsCoef: "Wood chips coefficient",
    woodChipsPriceM3: "Wood chips price for 1 m3",
    yes: "Yes",

    youSearchFor: "Your search for \"",
    foundNoResults: "\" found no results"
}

export default messages;
